export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-16" data-testid="privacy-policy-page">
      <h1 className="font-serif text-4xl font-medium text-nexa-charcoal mb-8">Privacy Policy</h1>
      <p className="text-muted-foreground mb-8">Last Updated: January 1, 2026</p>
      <div className="prose prose-lg max-w-none text-nexa-charcoal space-y-8">
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">1. Introduction</h2>
          <p className="text-muted-foreground leading-relaxed">Welcome to Nexaorbits. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website nexaorbits.store or make a purchase from us.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">2. Information We Collect</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">We collect information that you provide directly to us, including:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Name, email address, phone number, and shipping/billing address</li>
            <li>Payment information (processed securely through our payment providers)</li>
            <li>Order history and purchase preferences</li>
            <li>Communications you send to us</li>
            <li>Newsletter subscription preferences</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders, products, and services</li>
            <li>Send promotional communications (with your consent)</li>
            <li>Improve our website and customer experience</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">4. Information Sharing</h2>
          <p className="text-muted-foreground leading-relaxed">We do not sell, rent, or trade your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website, conducting our business, or servicing you.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">5. Data Security</h2>
          <p className="text-muted-foreground leading-relaxed">We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes SSL encryption for all data transmission.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">6. Your Rights</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">7. Contact Us</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Nexaorbits</strong><br />712 Greenfield Avenue, Detroit, MI 11201<br />Email: support@nexaorbits.store<br />Phone: +1-888-351-1122</p>
        </section>
      </div>
    </div>
  );
}
